module.exports = __webpack_public_path__ + "img/5425003947285.06db4a50.png";